import { render, staticRenderFns } from "./PurchasesTracking.vue?vue&type=template&id=0f1e2642&"
import script from "./PurchasesTracking.vue?vue&type=script&lang=js&"
export * from "./PurchasesTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports